import { defineComponent as _defineComponent } from 'vue'
import useVuelidate from "@vuelidate/core";
  import ModalWithHeader from "../ModalWithHeader.vue";
  import { computed, reactive, ref } from "vue";
  import { maxValue, minValue, required } from "@vuelidate/validators";
  import {
    formatPriceToNumber,
    formatPriceTrim,
  } from "@/helpers/transformation/price";
  import DropDown from "../dropdown/DropDown.vue";
  import ImageCropperModal from "./ImageCropperModal.vue";
  import store from "@/store";
  import { useToast } from "vue-toastification";
  import { CreateFacadeInterface } from "@/types/FacadeInterface";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'AddFacadeInGalleryModal',
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    builderId: {
      type: String,
      required: true,
    },
  },
  emits: ["close", "confirm"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const toast = useToast();
  const emits = __emit;
  const props = __props;

  const isUploadingImage = ref(false);
  const isLoading = ref(false);
  const imageToUpload = ref<{ data: string; file: File | null }>({
    data: "",
    file: null,
  });
  const isCropperModalOpen = ref(false);

  const formFields: {
    name: string | null;
    price: number | null;
    storeys: string | null;
    url: string | null;
    builderId: string | null;
  } = {
    name: null,
    price: null,
    storeys: null,
    url: null,
    builderId: props.builderId,
  };

  const rules = {
    name: { required },
    price: { required },
    builderId: { required },
    url: { required },
    storeys: { required, minValue: minValue(1), maxValue: maxValue(2) },
  };

  const form = reactive(Object.assign({}, formFields));

  const v$ = useVuelidate(rules, form);

  const validateForm = async () => {
    v$.value.$touch();
    const isValid = await v$.value.$validate();

    return isValid;
  };

  const updatePriceInput = (e: Event) => {
    e.preventDefault();
    const target = e.target as HTMLInputElement;
    const value = formatPriceTrim(target.value);

    form.price = formatPriceToNumber(value);
  };

  const onUploadImage = (e: InputEvent): void => {
    const files = (e.target as HTMLInputElement).files as FileList;

    if (!files[0]) {
      return;
    }

    const reader = new FileReader();

    reader.readAsDataURL(files[0]);
    reader.onload = () => {
      imageToUpload.value.data = reader.result as string;
      isCropperModalOpen.value = true;
    };
  };

  async function onCropImage(file: File) {
    isCropperModalOpen.value = false;
    imageToUpload.value.file = file;
    const formData = new FormData();

    formData.append("files", file);
    uploadImageRequest(props.builderId, formData);
  }

  const uploadImageRequest = async (builderId: string, image: FormData) => {
    isUploadingImage.value = true;

    try {
      const data = await store.dispatch("facade/uploadImage", {
        builderId,
        image,
      });

      form.url = data[0]?.value?.Location;
    } catch (error) {
      toast.error("An error occurred while uploading the image");
    } finally {
      isUploadingImage.value = false;
    }
  };

  const createFacade = async (dto: CreateFacadeInterface) => {
    try {
      isLoading.value = true;
      await store.dispatch("facade/createFacade", dto);
      emits("confirm");
      close();
    } catch (error) {
      toast.error("An error occurred while creating the facade.");
    } finally {
      isLoading.value = false;
    }
  };

  const clearForm = () => {
    v$.value.$reset();
    Object.assign(form, formFields);
  };

  const text = computed(() => {
    return "Are you sure you want to delete";
  });

  const close = () => {
    clearForm();
    emits("close");
  };

  const confirm = async () => {
    const isValid = await validateForm();
    const formDto = form as unknown as CreateFacadeInterface;

    if (!isValid) return;

    createFacade(formDto);
  };

const __returned__ = { toast, emits, props, isUploadingImage, isLoading, imageToUpload, isCropperModalOpen, formFields, rules, form, v$, validateForm, updatePriceInput, onUploadImage, onCropImage, uploadImageRequest, createFacade, clearForm, text, close, confirm, get useVuelidate() { return useVuelidate }, ModalWithHeader, computed, reactive, ref, get maxValue() { return maxValue }, get minValue() { return minValue }, get required() { return required }, get formatPriceToNumber() { return formatPriceToNumber }, get formatPriceTrim() { return formatPriceTrim }, DropDown, ImageCropperModal, get store() { return store }, get useToast() { return useToast }, get CreateFacadeInterface() { return CreateFacadeInterface } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})